<template>
    <div class="box">
        <div class="title">累计工单条数</div>
        <div class="content">{{ str }} <span class="text">条</span></div>

        <div class="listBox">
            <div class="list">
                <span class="iconfont icon-gongdan"></span>
                <span>未处理:</span>
                <span class="number">{{ task1 }}</span>
                <span>条</span>
            </div>
            <div class="list">
                <span class="iconfont icon-gongdanqueren"></span>
                <span>已处理:</span>
                <span class="number">{{ task2 }}</span>
                <span>条</span>
            </div>
        </div>
    </div>
</template>

<script>
import { QueryATaskCount } from '@/api/index.js';
export default {
    name: 'rightcard1',
    data() {
        return {
            task1: 0, // 未完成
            task2: 0, // 已完成
            str: '0000000'
        };
    },
    mounted() {
        this.getCount();
    },
    methods: {
        // 获取工单数量
        async getCount() {
            let { data } = await QueryATaskCount({ companyId: JSON.parse(localStorage.getItem('companyInfo')).companyId });
            this.task1 = data.result1.count;
            this.task2 = data.result2.count;

            let num = this.task1 + this.task2;
            this.str = num.toString().padStart(7, '0');
        }
    }
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.2);
    box-sizing: border-box;

    .title {
        color: aqua;
        font-size: 0.4rem;
        box-sizing: border-box;
        font-weight: bold;
        padding: 0.2rem;
    }

    .content {
        overflow: hidden;
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        align-items: center;
        font-size: 1rem;
        position: relative;
        letter-spacing: 0.3rem;
        border-bottom: 1px solid #14283e;

        .text {
            font-size: 0.4rem;
            position: absolute;
            right: 0;
            bottom: 0;
            letter-spacing: 0;
        }
    }

    .listBox {
        padding: 0.2rem;

        display: flex;
        flex-direction: column;
        justify-content: center;

        .list {
            font-size: 0.3rem;
            display: flex;
            align-items: center;
            margin-bottom: 0.1rem;
            font-weight: bold;

            .iconfont {
                font-size: 0.4rem;
                margin-right: 0.1rem;
                font-weight: normal;
            }

            .number {
                margin: 0 0.1rem;
                color: aqua;
            }
        }
    }
}
</style>